//transformación de fecha con input local (DD/MM/AAAA)
export const dateInput2Date = (fecha) => {
  const [day, month, year] = fecha.split("/");
  const isoFormattedStr = `${year}-${month}-${day}`;
  const date = new Date(isoFormattedStr);
  date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);

  return date;
};
